<header class="h-16 bg-card border-b border-border flex items-center justify-between pl-6 pr-3 shrink-0 z-30">
  <div class="flex items-center gap-4 flex-1">
    <!-- Mobile menu button -->
    <button
      type="button"
      (click)="emitMenuClick()"
      class="lg:hidden p-2 -ml-2 text-muted-foreground"
      aria-label="Mở menu"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5" aria-hidden="true">
        <path fill-rule="evenodd" d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
      </svg>
    </button>
    
    <!-- Company Name - Hidden on mobile, shown on desktop -->
    <!-- <div class="hidden lg:flex items-center gap-2 text-foreground cursor-pointer hover:bg-muted px-3 py-2 transition-colors" 
      [style.border-radius]="'var(--radius)'" 
      [style.font-size]="'var(--text-sm)'" 
      [style.font-weight]="'var(--font-weight-medium)'">
      <span>{{ companyName }}</span>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4 text-muted-foreground" aria-hidden="true">
        <path fill-rule="evenodd" d="M12.53.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06L13.5 2.81v18.38l2.03-2.03a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0l-3.25-3.25a.75.75 0 1 1 1.06-1.06l2.03 2.03V2.81L9.47 4.84a.75.75 0 0 1-1.06-1.06l3-3Z" clip-rule="evenodd" />
      </svg>
    </div> -->
    
    <!-- Search Bar -->
    <div class="relative w-full max-w-md">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground w-[18px] h-[18px]">
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.35-4.35"></path>
      </svg>
      <input 
        class="w-full pl-10 pr-4 py-2 bg-background border border-border text-foreground placeholder:text-muted-foreground focus:border-primary transition-all outline-none" 
        [style.border-radius]="'var(--radius-card1)'" 
        [style.font-size]="'var(--text-sm)'"
        [placeholder]="searchPlaceholder"
        type="text"
        autocomplete="off"
        pInputText
      />
    </div>
  </div>

  <div class="flex items-center gap-3">
    <!-- Language Selector -->
    <div class="relative">
      <!-- Language Dropdown -->
      <div *ngIf="isLanguageDropdownOpen">
        <!-- Backdrop -->
        <div
          class="fixed inset-0 z-[90]"
          (click)="closeLanguageBackdrop()"
        ></div>

        <!-- Dropdown Menu -->
        <div
          class="absolute right-0 top-full mt-2 bg-card border border-border z-[100] min-w-[180px]"
          [style.border-radius]="'var(--radius-card2)'"
          [style.box-shadow]="'var(--elevation-md)'"
        >
          <div class="py-2">
            <button
              type="button"
              (click)="saveLang('vi')"
              class="w-full flex items-center justify-between gap-3 px-4 py-2 transition-colors border-0 cursor-pointer text-left hover:bg-muted"
              [ngClass]="{
                'bg-primary/10 text-primary': translate.currentLang === 'vi',
                'text-foreground': translate.currentLang !== 'vi'
              }"
              [style.font-size]="'var(--text-sm)'"
            >
              <span class="flex items-center gap-2">
                <span
                  class="fi fi-vn w-5 h-[15px] shrink-0 rounded-sm"
                  aria-hidden="true"
                ></span>
                <span>Tiếng Việt</span>
              </span>
              <span
                *ngIf="translate.currentLang === 'vi'"
                class="w-1.5 h-1.5 rounded-full bg-primary shrink-0"
              ></span>
            </button>
            <button
              type="button"
              (click)="saveLang('en')"
              class="w-full flex items-center justify-between gap-3 px-4 py-2 transition-colors border-0 cursor-pointer text-left hover:bg-muted"
              [ngClass]="{
                'bg-primary/10 text-primary': translate.currentLang === 'en',
                'text-foreground': translate.currentLang !== 'en'
              }"
              [style.font-size]="'var(--text-sm)'"
            >
              <span class="flex items-center gap-2">
                <span
                  class="fi fi-gb w-5 h-[15px] shrink-0 rounded-sm"
                  aria-hidden="true"
                ></span>
                <span>English</span>
              </span>
              <span
                *ngIf="translate.currentLang === 'en'"
                class="w-1.5 h-1.5 rounded-full bg-primary shrink-0"
              ></span>
            </button>
            <button
              type="button"
              (click)="saveLang('cn')"
              class="w-full flex items-center justify-between gap-3 px-4 py-2 transition-colors border-0 cursor-pointer text-left hover:bg-muted"
              [ngClass]="{
                'bg-primary/10 text-primary': translate.currentLang === 'cn',
                'text-foreground': translate.currentLang !== 'cn'
              }"
              [style.font-size]="'var(--text-sm)'"
            >
              <span class="flex items-center gap-2">
                <span
                  class="fi fi-cn w-5 h-[15px] shrink-0 rounded-sm"
                  aria-hidden="true"
                ></span>
                <span>中文 (Zhōngwén)</span>
              </span>
              <span
                *ngIf="translate.currentLang === 'cn'"
                class="w-1.5 h-1.5 rounded-full bg-primary shrink-0"
              ></span>
            </button>
            <button
              type="button"
              (click)="saveLang('jn')"
              class="w-full flex items-center justify-between gap-3 px-4 py-2 transition-colors border-0 cursor-pointer text-left hover:bg-muted"
              [ngClass]="{
                'bg-primary/10 text-primary': translate.currentLang === 'jn',
                'text-foreground': translate.currentLang !== 'jn'
              }"
              [style.font-size]="'var(--text-sm)'"
            >
              <span class="flex items-center gap-2">
                <span
                  class="fi fi-jp w-5 h-[15px] shrink-0 rounded-sm"
                  aria-hidden="true"
                ></span>
                <span>日本語 (Nihongo)</span>
              </span>
              <span
                *ngIf="translate.currentLang === 'jn'"
                class="w-1.5 h-1.5 rounded-full bg-primary shrink-0"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Module Selector -->
    <div class="relative">
      <button
        type="button"
        (click)="toggleModuleDropdown()"
        class="bg-mute-hover rounded-full w-[40px] h-[40px] flex justify-center items-center border-none p-0 transition-colors text-muted-foreground bg-transparent"
        [ngClass]="{ 'text-primary': isModuleDropdownOpen }"
        aria-label="Module"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="w-[24px] h-[24px]"
          aria-hidden="true"
          data-slot="icon"
        >
          <path fill-rule="evenodd" d="M3 6a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3V6ZM3 15.75a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2.25Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3v-2.25Z" clip-rule="evenodd" />
        </svg>
      </button>

      <!-- Module Dropdown -->
      <div *ngIf="isModuleDropdownOpen">
        <!-- Backdrop -->
        <div
          class="fixed inset-0 z-[90]"
          (click)="closeModuleBackdrop()"
        ></div>
        
        <!-- Dropdown Menu -->
        <div 
          class="absolute top-full mt-2 bg-card border border-border z-[100] p-3 w-[520px] "
          [style.border-radius]="'var(--radius-card2)'"
          [style.box-shadow]="'var(--elevation-md)'"
          [style.right.px]="0"
        >
          <div class="pb-3 border-b border-border mb-3">
            <h3 class="text-foreground" [style.font-size]="'var(--text-sm)'" [style.font-weight]="'var(--font-weight-medium)'">
              Các Module
            </h3>
            <p class="text-muted-foreground mt-0.5" [style.font-size]="'var(--text-xs)'">
              Chọn module để truy cập
            </p>
          </div>

          <ng-content select="[shell-header-modules]"></ng-content>

          <div class="pt-3 border-t border-border mt-3">
            <button
              type="button"
              class="bg-transparent w-full flex items-center justify-center gap-2 px-3 py-2 text-primary hover:bg-primary/10 transition-colors border-0 cursor-pointer"
              [style.border-radius]="'var(--radius)'"
              [style.font-size]="'var(--text-xs)'"
              [style.font-weight]="'var(--font-weight-medium)'"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-[16px] h-[16px]" aria-hidden="true">
                <path fill-rule="evenodd" d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" />
              </svg>
              Xem tất cả module
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Avatar & User Menu -->
    <div class="relative">
      <button
        type="button"
        (click)="toggleUserMenu()"
        class="hidden sm:flex items-center gap-2 bg-transparent pl-2 pr-4 py-1.5 transition-colors border-0 cursor-pointer"
        [style.border-radius]="'var(--radius-pill)'"
      >
        <div
          class="w-[32px] h-[32px] bg-center bg-no-repeat bg-cover rounded-full shrink-0 bg-muted"
          [style.background-image]="'url(\'' + avatarUrl + '\')'"
        ></div>
        <div class="text-left min-w-0 hidden lg:block">
          <p class="text-foreground truncate text-nowrap" style="font-size: var(--text-sm); font-weight: var(--font-weight-medium);">
            {{ userName }}
          </p>
          <p class="text-muted-foreground truncate" style="font-size: var(--text-xs);">
            {{ userEmail }}
          </p>
        </div>
      </button>

      <!-- User Dropdown -->
      <div *ngIf="isUserMenuOpen">
        <!-- Backdrop -->
        <div
          class="fixed inset-0 z-[90]"
          (click)="closeUserBackdrop()"
        ></div>
        
        <!-- Dropdown Menu -->
        <div 
          class="absolute right-0 top-full mt-2 bg-card border border-border z-[100]"
          [style.border-radius]="'var(--radius-card2)'"
          [style.box-shadow]="'var(--elevation-md)'"
        >
          <!-- Menu Items -->
          <div class="py-2">
            <button
              type="button"
              class="bg-transparent w-full flex gap-2 px-2 py-2 items-center text-foreground hover:bg-muted transition-colors border-0 cursor-pointer text-left"
              [style.font-size]="'var(--text-sm)'"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-[16px] h-[16px] text-muted-foreground" aria-hidden="true">
                <path fill-rule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clip-rule="evenodd" />
              </svg>
              <span class="text-nowrap">Tài khoản của tôi</span>
            </button>
            <button
              type="button"
              class="bg-transparent w-full flex gap-2 px-2 py-2 items-center text-foreground hover:bg-muted transition-colors border-0 cursor-pointer text-left"
              [style.font-size]="'var(--text-sm)'"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-[16px] h-[16px] text-muted-foreground" aria-hidden="true">
                <path fill-rule="evenodd" d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567h-1.843ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z" clip-rule="evenodd" />
              </svg>
              <span class="text-nowrap">Cài đặt</span>
            </button>
          </div>

          <!-- Logout Section -->
          <div class="border-t border-border py-2">
            <button
              type="button"
              (click)="logoutClick()"
              class="bg-transparent w-full flex gap-2 px-2 py-2 items-center text-red-600 hover:bg-red-50 transition-colors border-0 cursor-pointer text-left font-medium"
              [style.font-size]="'var(--text-sm)'"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-[16px] h-[16px]" aria-hidden="true">
                <path fill-rule="evenodd" d="M16.5 3.75a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5h-6a.75.75 0 0 1 0-1.5h6V5.25h-6a.75.75 0 0 1 0-1.5h6Zm-5.03 4.72a.75.75 0 0 1 0 1.06L9.31 10.5l2.16 2.72a.75.75 0 1 1-1.18.94l-2.75-3.5a.75.75 0 0 1 0-.94l2.75-3.5a.75.75 0 0 1 1.06 0ZM4.5 12a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
              </svg>
              <span class="text-nowrap">Đăng xuất</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

